/* eslint-disable @typescript-eslint/no-explicit-any */

import { Box, Button, Flex, Text } from "@mantine/core";
import DetailCard from "../DetailCard";
import DetailSection from "../DetailSection";
import { IoSparklesSharp } from "react-icons/io5";

interface TabPanelSummaryProps {
  caseDetail: any;
  details: any;
  styles: any;
  summarizeCase: any;
}
const TabPanelSummary = ({
  styles,
  caseDetail,
  details,
  summarizeCase
}: TabPanelSummaryProps) => {
  console.log("TabPanelSummary: ", caseDetail.overviewSummary)
  return (
    <Box style={styles} pos={"relative"} w={"100%"}>
      <DetailSection title="Summary Overview">
        {caseDetail.overviewSummary && (
          <DetailCard
            key={`overview-summary-1`}
            createdAt={caseDetail.updatedAt}
            text={caseDetail.overviewSummary}
            isSummarized={true}
            onDelete={() => { }}
          />
        )}
        <Button
          className="btn-record"
          mt={10}
          radius={"lg"}
          w={250}
          onClick={() => summarizeCase()}
        >
          <Flex align={"center"}>
            <IoSparklesSharp />
            <Text ml={5}>Summarize</Text>
          </Flex>
        </Button>
      </DetailSection>

      <DetailSection title="History Summary">
        {caseDetail.historySummary && (
          <DetailCard
            key={`history-summary-1`}
            createdAt={caseDetail.updatedAt}
            text={caseDetail.historySummary}
            isSummarized={true}
            onDelete={() => { }}
          />
        )}
      </DetailSection>

      {/* Repeat for Plan sections */}

      <DetailSection title="Plan Summary">
        {caseDetail.planSummary && (
          <DetailCard
            key={`plan-summary-1`}
            createdAt={caseDetail.updatedAt}
            text={caseDetail.planSummary}
            isSummarized={true}
            onDelete={() => { }}
          />
        )}
      </DetailSection>

      {/* Repeat for Communication sections */}
      <DetailSection title="Communication">
        {details
          .filter((item: any) => {
            if (item.type == "COMMUNICATION") return true;
          })
          ?.map((item: any, index: number) => (
            <DetailCard
              key={`Communication-${index}`}
              createdAt={item.createdAt}
              text={item.summary}
              isSummarized={item.isSummarized}
              onDelete={() => { }}
            />
          ))}
      </DetailSection>
    </Box>
  );
};
export default TabPanelSummary;
